import {useQuery} from 'react-query'
import {deleteClass, fetchClassList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import ClassForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import {APIResponse} from '../../../types/type'
import {ClassBase} from './type'
import DeleteLabel from '../../../components/DeleteLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import PortalDropdown from '../../../components/PortalDropdown'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import TopBarProgress from 'react-topbar-progress-indicator'

const classBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/class',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function ClassView() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery<APIResponse<ClassBase[]>>(
    'class',
    fetchClassList,
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    class_status: ({value}: {value: string}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    Actions: ({row}: {row: {original: ClassBase}}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Class'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={ClassForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteClass(row.original.class_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Classes</title>
      </Helmet>
      <PageTitle breadcrumbs={classBreadcrumbs}>Class</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Class}
          fieldToLabelMap={viewProps.Class.primaryFieldsToLabelMap}
          Form={ClassForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Class'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={ClassForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm" className="ms-auto">
                Add Class
              </Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}
      <Toaster />
    </>
  )
}

export default ClassView
